<template>
  <div class="step-wrapper">
    <div>
      <img class="img-wrapper" :src="img" alt="step" />
    </div>
    <div>
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Step',
  props: {
    text: {
      type: String,
      default: function () {
        return 'hello world';
      }
    },
    img: {
      type: String,
      default: function () {
        return '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/referFriends/overview/step.scss';
</style>
